/** @format */
import { Modal, Button, Table } from "antd";
import ExcelJS from "exceljs";
import "moment/locale/id";
import * as FileSaver from "file-saver";
import notifAlert from "../NotifAlert";
import { useSelector } from "react-redux";

type generateModal = {
  openModal: boolean;
  dataMadrasah: any;
  title: any;
  sumberDana: any;
  onClose: () => void;
};
const ModalListMadrasah = ({
  openModal,
  dataMadrasah,
  title,
  sumberDana,
  onClose,
}: generateModal) => {
  const store = useSelector((state: any) => state.store);
  const refProvinsi = store.provinsi || [];
  const refKabkota = store.kabkota || [];
  let columns: any = [
    {
      title: "NSM",
      key: "nsm",
      dataIndex: "nsm",
    },
    {
      title: "Madrasah",
      key: "madrasah",
      dataIndex: "namaMadrasah",
    },
    {
      title: "Jenjang",
      key: "jenjang",
      dataIndex: "jenjang",
      render: (jenjang) => <div className="uppercase">{jenjang}</div>,
    },
    {
      title: "Provinsi",
      key: "provinsi",
      dataIndex: "kodeProvinsi",
      render: (kodeProvinsi) => {
        let namaProvinsi: any =
          refProvinsi.find((item) => item.kode === kodeProvinsi) || null;
        return namaProvinsi?.nama;
      },
    },
    {
      title: "Kab/Kota",
      key: "kabKota",
      dataIndex: "kodeKabkota",
      render: (kodeKabkota) => {
        let namaKabkota: any =
          refKabkota.find((item) => item.kode === kodeKabkota) || null;
        return namaKabkota?.nama;
      },
    },
  ];

  const handleExport = async () => {
    var ExcelJSWorkbook = new ExcelJS.Workbook();
    var worksheet = ExcelJSWorkbook.addWorksheet("Data");
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";

    worksheet.mergeCells("A1:I1");

    worksheet.getColumn("A").width = 5;
    worksheet.getColumn("B").width = 14;
    worksheet.getColumn("C").width = 40;
    worksheet.getColumn("D").width = 30;
    worksheet.getColumn("E").width = 30;
    worksheet.getColumn("F").width = 30;
    worksheet.getColumn("G").width = 30;
    worksheet.getColumn("H").width = 40;
    worksheet.getColumn("I").width = 50;
    worksheet.getColumn("J").width = 50;

    const headerCell = worksheet.getCell("A1");
    headerCell.font = {
      size: 11,
      underline: true,
      bold: true,
    };
    headerCell.alignment = { vertical: "middle", horizontal: "center" };
    headerCell.value = title;

    let dataTmp: any = [];
    dataMadrasah.map((e, i) => {
      return dataTmp.push([
        i + 1,
        e.nsm,
        e.namaMadrasah,
        e.jenjang,
        refProvinsi.find((item) => item.kode === e.kodeProvinsi).nama || null,
        refKabkota.find((item) => item.kode === e.kodeKabkota).nama || "",
      ]);
    });

    worksheet.addTable({
      name: "Table",
      ref: "A6",
      headerRow: true,
      style: {
        showRowStripes: true,
      },
      columns: [
        { name: "No" },
        { name: "NSM" },
        { name: "Madrasah" },
        { name: "Jenjang" },
        { name: "Provinsi" },
        { name: "Kab / Kota" },
      ],
      rows: dataTmp,
    });

    const excelBuffer = await ExcelJSWorkbook.xlsx.writeBuffer();
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `Laporan-Madrasah${fileExtension}`);
    notifAlert({
      type: "success",
      description: "Data berhasil di export",
    });
  };
  return (
    <>
      <Modal
        open={openModal}
        width={1300}
        title={title}
        onCancel={onClose}
        footer={[
          <Button onClick={onClose}>Kembali</Button>,
          <Button key="submit" type="primary" onClick={handleExport}>
            Export
          </Button>,
        ]}>
        <Table
          scroll={{ x: "1380" }}
          rowClassName="editable-row"
          columns={columns}
          dataSource={dataMadrasah}
          bordered
        />
      </Modal>
    </>
  );
};
export default ModalListMadrasah;
